import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Footer from './components/Footer'; 
import PrivacyPolicy from './pages/PrivacyPolicy'; 
import Verification from './pages/Verification'; 
import { Box } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import './App.css';
import ResetPassword from './pages/ResetPassword';
import ApmAppBar from './components/APMAppBar';
import About from './pages/About';
import Delete from './pages/DeletePolicy';
import InstallRedirect from './pages/InstallRedirect';
import Home from './pages/Home';

const theme = createTheme({
    palette: {
        background: {
            default: '#FFFFFF',
            paper: '#1e90ff',
        },
        text: {
            primary: "#FFFFFF",
        },
    },
    typography: {
        fontFamily: 'Montserrat',
        h1: {
            fontSize: '4rem',
            fontWeight: 700,
            color: '#ffffff', // Explicitly set color
            '@media (max-width:600px)': {
                fontSize: '2rem',
            },
        },
        h2: {
            fontFamily: 'Montserrat',
            fontSize: '3rem',
            fontWeight: 400,
            color: '#ffffff', // Explicitly set color
            '@media (max-width:600px)': {
                fontSize: '2rem',
            },
        },
        h5: {
            fontFamily: 'Montserrat',
            fontSize: '1.5rem',
            fontWeight: 400,
            color: 'dodgerblue', // Explicitly set color
            '@media (max-width:600px)': {
                fontSize: '1rem',
            },
        },
        button: {
            textTransform: 'none',
            fontSize: '1rem',
            color: '#000000',
        },
    },
    
    components: {
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        backgroundColor: '#1e90ff', // Hover background color
                        color: '#ffffff', // Hover text color
                    },
                },
            },
        },
    },
});



const App: React.FC = () => {
    return (
        <ThemeProvider theme={theme}>
            <Router>
                <Box
                    sx={{
                        height: '100vh', // Full viewport height
                        display: 'flex',
                        flexDirection: 'column',
                        position: 'relative', // Ensures relative positioning for the footer
                    }}
                >
                    <ApmAppBar />
                    <Box
                        sx={{
                            flexGrow: 1,
                            overflowY: 'auto',
                            paddingTop: '120px', 
                            backgroundColor: 'white', 
                        }}
                        >

                        <Routes>
                            <Route path="/" element={<Home />} />                            
                            <Route path="about" element={<About />} />
                            <Route path="privacy-policy" element={<PrivacyPolicy />} />
                            <Route path="/verification/:status" element={<Verification />} />
                            <Route path="/reset-password" element={<ResetPassword />} />
                            <Route path="/delete-account" element={<Delete />} />
                            <Route path="/install" element={<InstallRedirect />} />
                        </Routes>
                    </Box>
                    <Footer /> {/* Footer remains as a separate component */}
                </Box>
            </Router>
        </ThemeProvider>
    );
};

export default App;

